import React, { Component } from 'react';
// import { browserHistory } from 'react-router';
import './Assets/font/fonts.css';
import { connect } from 'react-redux';
import { Header, Footer, Sidebar } from '../../components';//Spinner
import { getProfile } from '../../ducks/auth';
import { getInstaFeedUser } from '../../ducks/instaFeed';
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap/dist/css/bootstrap.css';
let authToken = ''; try { authToken = localStorage.getItem('authToken'); } catch (e) {/** error */ }

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: true,
      auth: ''
    };
  }
  componentDidMount() {
    if (localStorage.getItem('userTyp') == 'instafeed' && localStorage.getItem('authToken')) {
      this.props.getInstaFeedUser();
    }
    if (authToken) {
      this.props.getProfile();

      if (localStorage.getItem('authToken')) {
        this.state.auth = localStorage.getItem('authToken');
        this.setState(this.state);
      }
      if (this.state.auth && localStorage.getItem('authToken')) {
        this.checkAuth();
      }
    }
    //use for shopify new app(display direct widget edit section)
    const authTokenInstaFeed = this.props && this.props.location && this.props.location.query ? this.props.location.query.tkn : '';
    if (authTokenInstaFeed) {
      let url = '';
      localStorage.setItem('authToken', authTokenInstaFeed);
      localStorage.setItem('userTyp', 'instafeed');
      document.body.classList.add('cls_wiser_insta_feed');
      if (window.location.hostname == 'localhost') {
        url = 'http://localhost:5001/widget/wdlist?wid=' + this.props.location.query.wid + '&id=' + this.props.location.query.id + '&cn=social&wdtnm=instagrampost';
      }
      else {
        url = 'https://app.wisernotify.com/widget/wdlist?wid=' + this.props.location.query.wid + '&id=' + this.props.location.query.id + '&cn=social&wdtnm=instagrampost';
      }
      window.open(url, '_self');
    }

    //use for check user is paid or not 
    let isPiad = this.props && this.props.location && this.props.location.query ? this.props.location.query.ispaid : '';
    if (isPiad) {
      localStorage.setItem('ispaid', true);
    }
  }

  checkAuth = () => {
    let that = this;
    setInterval(function () {
      if (that.state.auth !== localStorage.getItem('authToken')) {
        setTimeout(() => {
          window.location.href = process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?ds=type';
        }, 5000);
      }
    }, 5000);
  }

  componentWillMount() {
    this.checkLogin();
  }

  checkLogin = () => {
    const { location: { pathname } } = this.props;
    if (authToken) {
      if (pathname === process.env.REACT_APP_ROUTE_PREFIX + 'appsumo' ||
        pathname === process.env.REACT_APP_ROUTE_PREFIX + 'login' ||
        pathname === process.env.REACT_APP_ROUTE_PREFIX + 'signup' ||
        pathname === process.env.REACT_APP_ROUTE_PREFIX + 'reset' ||
        pathname === process.env.REACT_APP_ROUTE_PREFIX + 'ForgotPwd' ||
        pathname === process.env.REACT_APP_ROUTE_PREFIX + 'shopify')
        window.location = window.location.origin + process.env.REACT_APP_ROUTE_PREFIX + 'dashboard';
      this.setState({ loggedIn: true });

    } else {
      // if (pathname !== '/appsumo' && pathname !== '/login' && pathname !== '/signup' && pathname !== '/reset' && pathname !== '/ForgotPwd' && pathname !== '/shopify')
      //   window.location = window.location.origin + `/login${this.props.location.search}`;
      this.setState({ loggedIn: false });
    }
  }

  render() {
    return (
      <div className="website-app">
        {this.state.loggedIn &&
          <Sidebar
            location={this.props.location}
          />}
        <div className={this.state.loggedIn ? 'main' : 'main-outer'} id={this.state.loggedIn ? 'main-div' : ''}>
          {this.state.loggedIn && <Header />}
          {this.props.children}
        </div>
        {this.state.loggedIn && <Footer />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.getIn(['auth', 'profile']),
  loading: state.getIn(['loading', 'state'])
});

const mapDispatchToProps = {
  getProfile,
  getInstaFeedUser
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js